import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { useStepFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import MapAndList from './components/MapAndList';
import ShopFilter from './components/ShopFilter';
import ShopList from './components/ShopList';
import useShops from './components/ShopList/hooks/useShops';
import useLocation from './hooks/useLocation';

interface Params {
    isOrder: boolean;
    type: 'LIST' | 'MAP';
    originalItemId?: string;
}

const ShopListActivity: ActivityComponentType<Params> = ({ params }:{params:Params}) => {
  const { isOrder, type, originalItemId } = params;
  const { stepReplace } = useStepFlow('ShopListActivity');
  const { locationAgreed, ready } = useLocation();
  const {
    shops, isBlank, isLoading, fetchNext,
  } = useShops({
    locationAgreed, originalItemId, isOrder, ready,
  });
  return (
      <AppScreen>
          <Header title={isOrder ? '주문매장 선택' : '매장찾기'} />
          <TabList variant='transparent'>
              <TabItem selected={type === 'LIST'}
                       onClick={() => stepReplace({ type: 'LIST', isOrder, originalItemId })}>
                  리스트
              </TabItem>
              <TabItem selected={type === 'MAP'}
                       onClick={() => stepReplace({ type: 'MAP', isOrder, originalItemId })}>
                  지도
              </TabItem>
          </TabList>
          <ShopFilter/>
          {type === 'LIST' ? (
              <ShopList isOrder={isOrder}
                        originalItemId={originalItemId}
                        shops={shops}
                        isLoading={isLoading}
                        fetchNext={fetchNext}
                        isBlank={isBlank} />
          ) : (
              <MapAndList originalItemId={originalItemId}
                          isOrder={isOrder}
              />
          )}
      </AppScreen>
  );
};

export default ShopListActivity;
